import styled, { css } from "styled-components";
import { isPreviewableQuestionAsset } from "../document-processing/QuestionAssetPreviewStrip";

export const hasAnswerContent = (question) => Boolean(
  String(question?.answer_md ?? question?.answer ?? "").trim() ||
  question?.assets?.some((asset) => asset?.role === "answer" && isPreviewableQuestionAsset(asset)),
);

export const getAnswerDisplayText = (question, emptyText = "尚未輸入答案") =>
  String(question?.answer_md ?? question?.answer ?? "").trim() ||
  (hasAnswerContent(question) ? "圖片答案" : emptyText);

export const answerStateAttributes = ({ $empty }) => ({
  "data-answer-state": $empty ? "missing" : "present",
});

export const answerStateStyles = css`
  --answer-accent: ${({ $empty }) => $empty ? "#dc2626" : "#e3b341"};
  --answer-label-color: color-mix(in srgb, var(--app-surface-text, #202124) 68%, var(--answer-accent) 32%);
  border-left: 3px solid var(--answer-accent);
  border-color: var(--answer-accent);
  background: color-mix(in srgb, var(--app-question-card-bg, #fff) 88%, var(--answer-accent) 12%);
  color: var(--app-surface-text, #202124);
`;

export const AnswerStateBlock = styled.div.attrs(answerStateAttributes)`
  padding: 10px 12px;
  border-radius: 6px;
  ${answerStateStyles}
`;

export const AnswerStateBadge = styled.span.attrs(answerStateAttributes)`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  border-radius: 999px;
  font-size: 12px;
  white-space: nowrap;
  ${answerStateStyles}
`;
